export const colorScale = [
  { percent: 0, color: "#FE0000" },
  { percent: 20, color: "#FDAB00" },
  { percent: 40, color: "#FCF600" },
  { percent: 60, color: "#00E101" },
  { percent: 80, color: "#0100C6" },
  { percent: 100, color: "#0100C6" },
];
export const lineColors = [
  "#FF5733",
  "#33FF57",
  "#5733FF",
  "#33FFC5",
  "#FF33A1",
  "#33BFFF",
  "#FFC733",
  "#33FF33",
  "#FF5733",
  "#FF33B4",
  "#33FFA1",
  "#7A33FF",
  "#33FFD1",
  "#FF3333",
  "#FF7A33",
  "#000000"
];

export const videoExtensions = [
  "mp4",
  "avi",
  "mkv",
  "flv",
  "mov",
  "wmv",
  "heic",
  "m4v",
  "3gp",
  "mpv",
  "m4p",
];
export const imageExtensions = [
  "jpeg",
  "jpg",
  "png",
  "gif",
  "bmp",
  "svg",
  "webp",
  "heic",
  "heif",
  "tiff",
  "raw",
  "pict",
];